let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4RYm3")).then(() => parcelRequire('2kwCJ'));